var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPivot = function SvgPivot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8.394 2.02.312-.313A1 1 0 1 0 7.292.292l-1.999 2a1 1 0 0 0 0 1.415l2 2a1 1 0 0 0 1.413-1.414l-.246-.247C10.998 4.284 13 6.402 13 9V9a1 1 0 1 0 2-.034c-.018-3.71-2.94-6.74-6.606-6.946ZM3 7a1 1 0 0 0-2 0v.01c.005 3.721 2.932 6.763 6.605 6.97l-.312.312a1 1 0 1 0 1.414 1.415l1.999-2a1 1 0 0 0 0-1.414l-1.999-2.001a1 1 0 0 0-1.414 1.415l.246.246C5.001 11.716 3 9.598 3 7Zm5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgPivot;